// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2b-LK","title":"styles_title__ktf73"};